import baustein from "baustein";
import store from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";

/**
 * This module 'saved-search-signup-prompt' displays the signup
 * overlay when clicking "save search" buttons if you are a logged out user.
 *
 * @constructor
 * @alias module:components/saved-search-signup-prompt
 * @extends module:baustein
 */
export default baustein.register("saved-search-signup-prompt", {
    defaultOptions: {
        searchQuery: null,
        searchGender: null,
        searchNext: null,
        pageType: "signup form",
        pageSubType: "saved_search",
    },

    setupEvents(add) {
        add("click", this.onClick);
    },

    onClick(event) {
        event.preventDefault();

        analytics.event("saved search", "clicked", this.options.searchQuery);
        const options = {
            captureType: "signup_search",
            searchGender: this.options.searchGender,
            searchTerm: this.options.searchQuery,
            next: this.options.searchNext,
        };
        store.dispatch(openCustomerCaptureOverlay(options));
    },
});
